export const CUSTOMER_SERVICE_ALLOWED_FILE_TYPES = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/gif',
];

export const MAX_CUSTOMER_SERVICE_ATTACHMENT_COUNT = 3;

export const getRemainingCustomerServiceAttachmentCount = (
  currentAttachmentCount: number
): number => Math.max(MAX_CUSTOMER_SERVICE_ATTACHMENT_COUNT - currentAttachmentCount, 0);

export const CUSTOMER_SERVICE_UNSUPPORTED_ATTACHMENT_MESSAGE =
  '고객 문의에는 JPG, JPEG, PNG, GIF 파일 형식만 첨부할 수 있습니다. ' +
  '기타 파일 형식은 고객센터 메일(linkareer_cs@linkareer.com)로 첨부 부탁드립니다.';

export const CUSTOMER_SERVICE_SUBMIT_ERROR_MESSAGE =
  '죄송합니다. 의견을 보내는 중 오류가 발생했습니다.';

const UNSUPPORTED_SUGGESTION_ATTACHMENT_TYPE = 'UNSUPPORTED_SUGGESTION_ATTACHMENT_TYPE';

type GraphQLErrorShape = {
  message?: unknown;
  extensions?: {
    code?: unknown;
  };
};

const getGraphQLErrors = (error: unknown): GraphQLErrorShape[] => {
  if (!error || typeof error !== 'object') {
    return [];
  }

  const errorRecord = error as Record<string, unknown>;
  if (Array.isArray(errorRecord.graphQLErrors)) {
    return errorRecord.graphQLErrors as GraphQLErrorShape[];
  }

  const response = errorRecord.response;
  if (!response || typeof response !== 'object') {
    return [];
  }

  const responseData = (response as Record<string, unknown>).data;
  if (!responseData || typeof responseData !== 'object') {
    return [];
  }

  const graphQLErrors = (responseData as Record<string, unknown>).errors;
  return Array.isArray(graphQLErrors) ? (graphQLErrors as GraphQLErrorShape[]) : [];
};

export const getCustomerServiceSubmitErrorMessage = (error: unknown): string => {
  const unsupportedAttachmentError = getGraphQLErrors(error).find(
    (graphQLError) =>
      graphQLError?.extensions?.code === UNSUPPORTED_SUGGESTION_ATTACHMENT_TYPE &&
      typeof graphQLError.message === 'string'
  );

  return typeof unsupportedAttachmentError?.message === 'string'
    ? unsupportedAttachmentError.message
    : CUSTOMER_SERVICE_SUBMIT_ERROR_MESSAGE;
};
